<template>
    <div class="pt_nodata">
        <p class="pt_nodata-avator" />
        <template v-if="isShowTips">
            <p class="pt_nodata-title">
                {{ nodataTips ? nodataTips : $t('view.table.noData') }}
            </p>
            <p
                v-for="(item, index) in nodataInfo"
                :key="index"
                class="pt_nodata-item"
                v-html="item"
            />
        </template>
    </div>
</template>

<script>
export default {
    name: 'PtNodata',
    props: {
        nodataInfo: {
            type: Array,
            default: () => [],
        },
        nodataTips: {
            type: String,
        },
        isShowTips: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss">
.pt_nodata {
    display: block;
    .pt_nodata-avator {
        height: 180px;
        width: 180px;
        margin: 0 auto;
        background: url('../assets/images/nodata-new.png') top center no-repeat;
    }
    .pt_nodata-title {
        color: #607D8B;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 16px;
    }
    .pt_nodata-item {
        text-align: center;
        color: $neutral-blue-300;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 4px;
        &:last-of-type {
            margin-bottom: 0;
        }
    }
}
</style>
